<template>
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.05469 9.8125C5.28906 10.0469 5.6875 10.0469 5.92188 9.8125L12.8125 2.92188C13.0469 2.6875 13.0469 2.28906 12.8125 2.05469L11.9688 1.21094C11.7344 0.976562 11.3594 0.976562 11.125 1.21094L5.5 6.83594L2.85156 4.21094C2.61719 3.97656 2.24219 3.97656 2.00781 4.21094L1.16406 5.05469C0.929688 5.28906 0.929688 5.6875 1.16406 5.92188L5.05469 9.8125Z"
      fill="white"
    />
  </svg>
</template>
